export interface JoinTableRequest {
  name: string;
  email: string;
  phone: string;
}

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const submitJoinTable = async (payload: JoinTableRequest) => {
  const response = await fetch(`${API_BASE_URL}/createmember`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const error = await response.json();
    throw error;
  }

  return response.json();
};
